const onlyNumbersRegex = /^[0-9.]+$/;
const phoneRegex = /[+()\d-]+$/;
const alphabet = [
    'a',
    'b',
    'c',
    'd',
    'e',
    'f',
    'g',
    'h',
    'i',
    'j',
    'k',
    'l',
    'm',
    'n',
    'o',
    'p',
    'q',
    'r',
    's',
    't',
    'u',
    'v',
    'w',
    'x',
    'y',
    'z',
];

const ifStringEmpty = text => {
    if (text == null) {
        return true;
    }

    text = text.trim();
    return text.length === 0 && !text.trim() && text.trim() !== ' ';
};

const randomKey = length => {
    let text = '';
    let possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

    for (let i = 0; i < length; i++)
        text += possible.charAt(Math.floor(Math.random() * possible.length));

    return text;
};

const getRandomColor = () => {
    let letters = '0123456789ABCDEF';
    let color = '#';
    for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
};

const formatBytes = (a, b) => {
    if (0 == a) return '0 Bytes';
    var c = 1024,
        d = b || 2,
        e = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
        f = Math.floor(Math.log(a) / Math.log(c));
    return parseFloat((a / Math.pow(c, f)).toFixed(d)) + ' ' + e[f];
};

const getAlphabetLetterByIndex = index => {
    return alphabet.length > index && index > -1 ? alphabet[index] : null;
};

const getAge = dateString => {
    let today = new Date();
    let birthDate = dateString;
    let age = today.getFullYear() - birthDate.getFullYear();
    let m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
    }
    return age;
};

const dataURItoBlob = dataURI => {
    // convert base64 to raw binary data held in a string
    // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
    var byteString = atob(dataURI.split(',')[1]);

    // separate out the mime component
    var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

    // write the bytes of the string to an ArrayBuffer
    var ab = new ArrayBuffer(byteString.length);

    // create a view into the buffer
    var ia = new Uint8Array(ab);

    // set the bytes of the buffer to the correct values
    for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
    }

    // write the ArrayBuffer to a blob, and you're done
    var blob = new Blob([ab], { type: mimeString });
    return blob;
};

const dynamicSort = (property, type) => {
    let sortOrder = 1;
    if (property[0] === '-') {
        sortOrder = -1;
        property = property.substr(1);
    }
    return function (a, b) {
        let result;
        switch (type) {
            case 'string':
                result =
                    a[property].toLowerCase() < b[property].toLowerCase()
                        ? -1
                        : a[property].toLowerCase() > b[property].toLowerCase()
                        ? 1
                        : 0;
                break;
            case 'number':
                result = +a[property] < +b[property] ? -1 : +a[property] > +b[property] ? 1 : 0;
                break;
            case 'date':
                result = a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
                break;
            default:
                result = a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
        }
        return result * sortOrder;
    };
};

export {
    ifStringEmpty,
    randomKey,
    alphabet,
    getRandomColor,
    onlyNumbersRegex,
    phoneRegex,
    getAlphabetLetterByIndex,
    getAge,
    dynamicSort,
    formatBytes,
    dataURItoBlob,
};
